import './MultiSelectSearchList.a60504a976e9054e07aaa680fac3b5ab.css';
export default {"container":"_container_jxtdh_1","header":"_header_jxtdh_1","title":"_title_jxtdh_1","search":"_search_jxtdh_1","list":"_list_jxtdh_1"};